export const logo="https://i.ibb.co/5Mf2jFL/Crypto-Knights-logos-black.png";

export const Rapid_key = process.env.REACT_APP_RAPID_API_KEY